import axios from "axios";
import { toNumber } from "lodash-es";
import { useQuery } from "react-query";

import { LocationResult } from "../types";

interface GetLocationOptions {
  count: number;
}

interface GeopuntLocationResult {
  LocationResult: GeopuntLocationEntry[];
}

interface GeopuntLatLng {
  Lat_WGS84: number;
  Lon_WGS84: number;
  X_Lambert72: number;
  Y_Lambert72: number;
}

interface GeopuntLocationEntry {
  Municipality: string;
  Zipcode: string;
  Thoroughfarename: string;
  Housenumber: string;
  FormattedAddress: string;
  ID: number;
  Location: GeopuntLatLng;
  BoundingBox: { LowerLeft: GeopuntLatLng; UpperRight: GeopuntLatLng };
}

const DEFAULT_LOCATION_OPTIONS: GetLocationOptions = { count: 8 };

export const useGeopuntLocation = (
  query: string,
  customOptions?: GetLocationOptions
) => {
  async function fetch() {
    const baseUrl = "https://loc.geopunt.be/v4";
    const url = `${baseUrl}/location`;
    const options = { ...DEFAULT_LOCATION_OPTIONS, ...customOptions };

    const config = {
      params: {
        q: query,
        c: options.count,
        type: "Thoroughfarename",
      },
      //   adapter: jsonpAdapter,
    };
    const response = await axios.get<GeopuntLocationResult>(url, config);
    return response.data.LocationResult.map((item): LocationResult => {
      return {
        id: item.ID,
        lat: item.Location.Lat_WGS84,
        lng: item.Location.Lon_WGS84,
        displayName: item.FormattedAddress,
        boundingbox: [
          [
            item.BoundingBox.UpperRight.Lat_WGS84,
            item.BoundingBox.UpperRight.Lon_WGS84,
          ],
          [
            item.BoundingBox.LowerLeft.Lat_WGS84,
            item.BoundingBox.LowerLeft.Lon_WGS84,
          ],
        ],
      };
    });
  }

  return useQuery(["geopunt", "location", query], fetch);
};

interface NominatimLocationResult {
  display_name: string;
  osm_id: number;
  class: string;
  lat: string;
  lon: string;
  type: string;
  boundingbox: [string, string, string, string];
}

export const useNominatimLocation = (
  query: string,
  customOptions?: GetLocationOptions
) => {
  async function fetch() {
    const baseUrl = " https://nominatim.openstreetmap.org";
    const url = `${baseUrl}/search`;
    const options = { ...DEFAULT_LOCATION_OPTIONS, ...customOptions };

    const config = {
      params: {
        format: "json",
        q: query,
        limit: options.count,
      },
    };
    const response = await axios.get<NominatimLocationResult[]>(url, config);

    return response.data.map((item): LocationResult => {
      return {
        id: item.osm_id,
        lat: toNumber(item.lat),
        lng: toNumber(item.lon),
        displayName: item.display_name,
        boundingbox: [
          [toNumber(item.boundingbox[0]), toNumber(item.boundingbox[2])],
          [toNumber(item.boundingbox[1]), toNumber(item.boundingbox[3])],
        ],
      };
    });
  }

  return useQuery(["nominatim", "location", query], fetch);
};
